'use strict';

const select2 = require('select2');

/**
 * Generates a custom option element for a select dropdown.
 * If the option has an associated icon, it creates an HTML structure with the icon.
 * @param {Object} option - The option object provided by the select plugin.
 * @returns {string|jQuery} - The original text if no icon is associated, or a jQuery object containing the custom HTML structure with an icon.
 */
function customOptions(option) {
    if (!option.id) {
        return option.text;
    }
    var $optionEle = $(option.element);
    if ($optionEle.hasClass('hide') && !$optionEle.hasClass('no-hide')) {
        return null;
    }
    var $option = option.text;
    if ($optionEle.data('icon')) {
        $option = $('<span class="icon-parent"><i class="icon icon-size-s"></i> <span></span></span>');
        $option.find('span').text(option.text);
        $option.find('i').addClass('icon-' + $optionEle.data('icon'));
    }
    return $option;
}

/**
 * Initializes custom select elements using the Select2 jQuery plugin.
 *
 * This function finds all elements with the class `.custom-select` and applies the Select2 plugin
 * with the search box disabled (using `minimumResultsForSearch: -1`).
 *
 * @function customSelectInit
 */
function customSelectInit() {
    var customSelectElements = $('.custom-select');
    customSelectElements.each(function () {
        const $this = $(this);
        const $formElement = $this.closest('.form-element');
        var customClass = $this.data('customClass') ? $this.data('customClass') : '';
        var placeholder = $this.data('placeholder') || '';
        var width = $this.data('width') || '';

        var selectObj = {
            minimumResultsForSearch: -1,
            templateSelection: customOptions,
            templateResult: customOptions,
        };

        if (width) {
            selectObj.width = width;
        }
        if (customClass) {
            selectObj.dropdownCssClass = customClass;
            selectObj.selectionCssClass = customClass;
        }
        if (placeholder) {
            selectObj.placeholder = placeholder;
        }
        if ($formElement.length === 1) {
            selectObj.dropdownParent = $formElement;
        }
        if (typeof $.fn.select2 === 'function') {
            $this.select2(selectObj);
        }
        var container = $this.next('.select2-container');
        if ($this.val()) {
            container.addClass('select2-active');
        } else {
            container.removeClass('select2-active');
        }
    });
}

module.exports = function () {
    select2();
    customSelectInit();
    // Triiger this event if have custom select after an ajax
    $(document).on('customSelectInit', customSelectInit);
    // Adding active class to custom select after value is selected.
    $(document).on('change', '.custom-select', function () {
        var container = $(this).nextAll('.select2-container');
        if ($(this).val()) {
            container.addClass('select2-active');
        } else {
            container.removeClass('select2-active');
        }
    });
};
